import { Injectable, Injector } from '@angular/core';
import { Extender } from 'src/shared/helpers/extender';
import { Preference } from 'src/shared/models';

@Injectable({
  providedIn: 'root'
})
export class SettingService extends Extender {

  constructor(protected injector: Injector) {
    super(injector);
  }

  public getUserPreference(uid) {
    return this.afStore$.doc<Preference>(`preferences/${uid}`).valueChanges();
  }

  public upsertPreferences(data) {
    data.id = this.afStore$.createId();
    return this.afStore$.doc(`preferences/${data.uid}`).set(data, { merge: true });
  }

  public removePreference(id) {
    return this.afStore$.doc(`preferences/${id}`).delete();
  }
}
